import { proNavigator } from "single-spa/react-app/ProNavigator";

const WEBSITE_PERFORMANCE_STATE = "digitalsuite_website_websiteperformance";

export const getGrowthOverviewDomainHref = async (domain: string): Promise<string> => {
    const { country, webSource, duration } = proNavigator.getParams();

    return proNavigator.hrefAsync(WEBSITE_PERFORMANCE_STATE, {
        country,
        webSource,
        duration,
        isWWW: "*",
        key: domain,
    });
};
